export default "__VITE_ASSET__BS2D2sa7__"